import React from "react"
import { dummyClick } from "../utilities"

const ReadingControlIcon = ({ src, title, onClick, id, className }) => (
  <img
    src={src}
    id={id}
    className={`a-nav-1 block mb3 grow ${className}`}
    title={title}
    onClick={onClick}
  />
)

ReadingControlIcon.defaultProps = {
  src: "/images/webreader/ic-prev.svg",
  title: "EN title",
  onClick: dummyClick,
  id: "",
  className: ""
}

export default ReadingControlIcon
